import FallbackPage from "./errors/FallbackPage";

const SuspenseFallback = () => {
  return <FallbackPage loading />;
};

export default SuspenseFallback;
